import { getAriaText } from '@utils/helpers';
import i18n from '@/i18n';

export default class JSQuoteTickerRenderer {
  eGui;
  eList;
  values;
  classMap = {
    '-1': 'negative',
    '-0.5': 'semi-negative',
    '0': '',
    '0.5': 'semi-positive',
    '1': 'positive'
  };

  init(params) {
    if (!params.node.group) {
      const template = document.createElement('div');
      template.classList.add('c-js-quote-ticker');
      const list = document.createElement('div');
      list.classList.add('list');
      template.appendChild(list);
      this.eList = list;
      this.eGui = template;

      this.setAccessibilityElements(params);
      this.refresh(params, true);
    }
  }

  getGui() {
    return this.eGui;
  }

  refresh(params) {
    if (!params.value) {
      return false;
    } else if (params.node.group) {
      return true;
    }
    this.parseTicks(params.value);
    this.renderList();
    return true;
  }

  parseTicks(ticks) {
    let i = ticks.length - 1;
    this.values = [];
    while (i > 0 && this.values.length < 10) {
      const prevTick = ticks[i - 1];
      const tick = ticks[i];
      let val = 0;
      if (tick.bid > prevTick.bid && tick.ask > prevTick.ask) val = 1;
      else if (tick.bid > prevTick.bid || tick.ask > prevTick.ask) val = 0.5;
      else if (tick.bid < prevTick.bid && tick.ask < prevTick.ask) val = -1;
      else if (tick.bid < prevTick.bid || tick.ask < prevTick.ask) val = -0.5;
      if (val) this.values.unshift(val);
      else ticks.splice(i, 1);
      i--;
    }
    // remove unneeded ticks from data row
    if (i > 0) ticks.splice(0, i);
  }

  renderList() {
    if (!this.values.length) {
      this.eList.innerHTML = '';
    } else {
      const childrenCount = this.eList.childNodes.length;
      const updateCount = Math.min(childrenCount, this.values.length);
      let i = 0;
      for (i = 0; i < updateCount; i++) {
        this.eList.childNodes[i].style.display = 'inline-block';
        this.eList.childNodes[i].setAttribute('class', this.classMap[this.values[i]]);
      }
      if (childrenCount > this.values.length) {
        while (i < childrenCount) {
          this.eList.childNodes[i].style.display = 'none';
          i++;
        }
      } else if (childrenCount < this.values.length) {
        while (i < this.values.length) {
          const listEle = document.createElement('div');
          listEle.setAttribute('class', this.classMap[this.values[i]]);
          this.eList.appendChild(listEle);
          i++;
        }
      }
    }
  }

  destroy() {}

  setAccessibilityElements(params) {
    const isAccessible = params.state.applicationSettings.accessibility.settings.accessibilityFeatures;
    if (isAccessible) {
      const srElement = document.createElement('span');
      srElement.classList.add('sr-only');
      srElement.innerText = this.getAriaText(params);
      this.eGui.prepend(srElement);
    }
  }

  getAriaText(params) {
    return `${getAriaText(params)} ${i18n.t('white-label.components.quoteTrend.quoteTrendGraphic')}`;
  }
}
